var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2.64678C17.2424 2.64678 19.871 5.21429 19.871 8.38148C19.871 11.5487 17.2424 14.1162 14 14.1162C10.7576 14.1162 8.12903 11.5487 8.12903 8.38148C8.12903 5.21429 10.7576 2.64678 14 2.64678ZM22.5806 8.38148C22.5806 3.75252 18.739 0 14 0C9.26104 0 5.41935 3.75252 5.41935 8.38148C5.41935 13.0104 9.26104 16.763 14 16.763C18.739 16.763 22.5806 13.0104 22.5806 8.38148Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7488 23.7748C17.4446 21.5755 10.5554 21.5755 4.2512 23.7748C3.32676 24.0973 2.70968 24.9526 2.70968 25.9114V28.2327C2.70968 29.5226 3.87929 30.5134 5.18658 30.331L6.91068 30.0904C11.613 29.4343 16.387 29.4343 21.0893 30.0904L22.8134 30.331C24.1207 30.5134 25.2903 29.5226 25.2903 28.2327V25.9114C25.2903 24.9526 24.6732 24.0973 23.7488 23.7748ZM3.33984 21.2822C10.2334 18.8773 17.7666 18.8773 24.6602 21.2822C26.663 21.9809 28 23.834 28 25.9114V28.2327C28 31.1333 25.3699 33.3614 22.4302 32.9512L20.7061 32.7106C16.2579 32.0899 11.742 32.0899 7.29389 32.7106L5.56978 32.9512C2.63009 33.3614 0 31.1333 0 28.2327V25.9114C0 23.834 1.33697 21.9809 3.33984 21.2822Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalIcon);
export default __webpack_public_path__ + "static/media/PersonalIcon.1ab7746c4adf68481fe943b0730dbe65.svg";
export { ForwardRef as ReactComponent };